/**
 * Add depth to any .depth-ill element that holds a foreground and background.
 */
export function depthIllustrations() {
    let illustrations = document.querySelectorAll( '.depth-ill' );

    for (let i = 0; i < illustrations.length; ++i) {
        let illustration = illustrations[i],
            foreground = illustration.querySelector( '.depth-ill__foreground' ),
            background = illustration.querySelector( '.depth-ill__background' );

        illustration.style.height = parseInt( foreground.offsetHeight ) + 'px';

        if( foreground, background ) {

                let viewportWidth = window.innerWidth,
                    viewportHeight = window.innerHeight;

                function percentagePosition( eventX, eventY ) {
                    let y = eventY / viewportHeight,
                        x = eventX / viewportWidth;
                    return [ x, y ];
                }

                function mouseMoveHandler( event ) {
                    let mouseX = event.clientX,
                        mouseY = event.clientY;

                    let percentPos = percentagePosition( mouseX, mouseY ),
                        percentPosX = percentPos[0],
                        percentPosY = percentPos[1];

                    function moveLayers( percentX, percentY ){
                        let foregroundMoveMax = 25,
                            backgroundMoveMax = 10,
                            foregroundX = ( ( percentX * 2 - 1 ) * foregroundMoveMax ),
                            foregroundY = ( ( percentY * 2 - 1 ) * foregroundMoveMax ),
                            backgroundX = ( ( percentX * 2 - 1 ) * backgroundMoveMax ),
                            backgroundY = ( ( percentY * 2 - 1 ) * backgroundMoveMax );

                        foreground.style.transform = 'translate( ' + foregroundX + 'px, ' + foregroundY + 'px )';
                        background.style.transform = 'translate( ' + backgroundX + 'px, ' + backgroundY + 'px )';
                    }

                    moveLayers( percentPosX, percentPosY );
                }

                document.addEventListener('mousemove', mouseMoveHandler);
        }

    }
}


// WEBPACK FOOTER //
// ./src/js/depth-illustrations.js